import { render, staticRenderFns } from "./AboutApplications.vue?vue&type=template&id=0c20593d"
import script from "./AboutApplications.vue?vue&type=script&lang=js"
export * from "./AboutApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports